export default __webpack_public_path__ + "d177af80bfb5091ceafa5bc2ec97ba96.png";